<template>
  <step-component :backURL="'getting-started-step-9'">
    <download-game>
      <h3>STEP 10 of 10</h3>
    </download-game>
  </step-component>
</template>

<script>
import DownloadGame from '@/components/steps/DownloadGame.vue'
import StepComponent from '@/components/StepComponent.vue';

export default {
  components: {
    DownloadGame,
    StepComponent
  },
  mounted () {
    window.scrollTo(0, 0)
  }
}
</script>

